import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { BRAND, HERO_STATS, HERO_CITIES, HERO_PILLS, IMAGES } from "../mock";
import { useBooking } from "../App";

const Hero = () => {
  const { openBooking } = useBooking();
  const [cityIdx, setCityIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCityIdx((i) => (i + 1) % HERO_CITIES.length), 2000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative bg-gradient-to-br from-[#eef4fb] via-white to-[#fdf3e6] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-10 items-center py-12 lg:py-16">
        {/* Left */}
        <div className="reveal">
          <span className="inline-flex items-center gap-2 bg-white shadow-sm border border-orange-brand/20 text-orange-brand text-xs sm:text-sm font-bold px-4 py-2 rounded-full mb-5">
            {BRAND.discount} OFF FOR NEW USERS
            <span className="bg-orange-brand text-white px-2 py-0.5 rounded-md">{BRAND.coupon}</span>
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-[3.4rem] font-extrabold leading-[1.1] text-navy font-head">
            India's #1 Rated <br />
            <span className="text-orange-brand">Laundry &amp; Dry Cleaning</span> Service
          </h1>
          <p className="mt-5 text-lg text-navy/70 font-medium">
            Now Serving in{" "}
            <span key={cityIdx} className="text-bluelink font-bold inline-block reveal">{HERO_CITIES[cityIdx]}</span>
          </p>

          <div className="flex flex-wrap gap-3 mt-7">
            <button
              onClick={openBooking}
              className="inline-flex items-center gap-2 bg-orange-brand hover:bg-[#e0850f] text-white font-semibold px-7 py-3.5 rounded-full shadow-lg shadow-orange-brand/25 transition-all hover:gap-3"
            >
              Book a Service <ArrowRight size={19} />
            </button>
            <a
              href={`https://wa.me/${BRAND.whatsapp}?text=Hi%2C%20I%20would%20like%20to%20book%20a%20service`}
              target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white border border-gray-200 hover:border-[#25D366] text-navy font-semibold px-7 py-3.5 rounded-full shadow-sm transition-colors"
            >
              <svg viewBox="0 0 24 24" width="20" height="20" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" /></svg>
              Chat on WhatsApp
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-4 gap-3 mt-9 max-w-lg">
            {HERO_STATS.map((s) => (
              <div key={s.label} className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto rounded-full bg-white shadow-md border border-gray-100 flex items-center justify-center text-navy font-extrabold text-sm sm:text-base font-head">
                  {s.value}
                </div>
                <p className="text-xs sm:text-sm text-navy/60 font-semibold mt-2">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right image with hotspots */}
        <div className="relative hidden md:block reveal">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[500px] bg-navy">
            <img src={`${IMAGES.dryClean1}?w=800&q=80`} alt="Freshly cleaned garments on hangers" className="w-full h-full object-cover" />
          </div>
          {HERO_PILLS.map((p) => (
            <span
              key={p.label}
              className="absolute bg-white shadow-lg text-navy text-xs font-semibold px-3 py-2 rounded-full flex items-center gap-2 floaty"
              style={{ top: p.top, left: p.left }}
            >
              <span className="w-2 h-2 rounded-full" style={{ background: p.color }} />
              {p.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
